module.exports = __webpack_public_path__ + "img/step-arrow.40d80c12.png";